import React from 'react';
import { ActionBase } from '../ActionBase';
import { Store } from '../Store';
import { copyObject } from 'common/copyObject';

export type AuthorizeV1Data = {
	burl: string;
	bsn: string;
	scd?: string;
	shopcd?: string;
};

export const initialAuthorizeV1Data: AuthorizeV1Data = {
	burl: undefined,
	bsn: undefined,
	scd: undefined,
	shopcd: undefined,
};

//////////////////////////////////////////////////
// SaveAction
//////////////////////////////////////////////////
// Action
class SaveAction extends ActionBase {
	authorizeV1Data: AuthorizeV1Data;
}
// Action name
const SaveActionName = SaveAction.toString();

// Action generator
export const saveGenerator = async (dispatch: React.Dispatch<ActionBase>, authorizeV1Data: AuthorizeV1Data) => {
	const action = {
		action: SaveActionName,
		authorizeV1Data,
	} as SaveAction;

	dispatch(action);
};

// Reducer
const saveReducer = (state: Store, action: ActionBase): Store => {
	const thisAction = action as SaveAction;
	const newState: Store = copyObject(state);
	newState.authorizeV1Data = thisAction.authorizeV1Data;
	return newState;
};

////////////////////////////////////////////////////////////////////////////////
// Reduce functions finder
////////////////////////////////////////////////////////////////////////////////
export const AuthorizeV1ReduceFunction = (state: Store, action: ActionBase): Store => {
	switch (action.action) {
		case SaveActionName:
			return saveReducer(state, action);
	}
	return null;
};
